<script setup>
import { computed, useSlots } from 'vue';
import JetSectionTitle from './SectionTitle.vue';

defineEmits(['submitted']);
defineProps({ fullWidth: Boolean });

const hasActions = computed(() => !!useSlots().actions);
</script>

<template>
  <div class="md:grid md:gap-6" :class="fullWidth ? '' : 'md:grid-cols-3'">
    <JetSectionTitle>
      <template #title>
        <slot name="title" />
      </template>
      <template #description>
        <slot name="description" />
      </template>
    </JetSectionTitle>

    <div class="mt-5 md:mt-0" :class="fullWidth ? '' : 'md:col-span-2'">
      <form @submit.prevent="$emit('submitted')">
        <div class="px-4 py-5 bg-white md:p-6 shadow" :class="hasActions ? 'md:rounded-t-md' : 'md:rounded-md'">
          <!-- :class="hasActions ? 'md:rounded-tl-md md:rounded-tr-md' : 'md:rounded-md'" -->
          <div class="grid grid-cols-6 gap-6">
            <slot name="form" />
          </div>
        </div>

        <div
          v-if="hasActions"
          class="flex items-center justify-end px-4 py-3 bg-gray-50 text-right md:px-6 shadow md:rounded-bl-md md:rounded-br-md"
        >
          <slot name="actions" />
        </div>
      </form>
    </div>
  </div>
</template>
